var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Estadias realizadas","storeName":"Rent_orders","parentStoreName":"Users","parentUrlKey":"user_id","labelAddNew":"Agregar","canAdd":false,"canEdit":true,"canDelete":true,"labelBack":"Atrás"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }